import React from 'react'
import { LinkBtn, l } from '@manychat/manyui'

import { OfferStepTypes } from 'common/settings/components/SettingsPanel/BillingInfoProducts/CancelSubscriptionModal/types'
import { analyticsService } from 'utils/services/analytics'

import SupportImg from './assets/support.svg'

const BadExpirence = () => {
  const handleClickSupport = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.SUPPORT}.CLICK_SUPPORT`,
    )
  }
  const handleClickCommunity = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.SUPPORT}.FACEBOOK_COMMUNITY`,
    )
  }
  return (
    <>
      <div className="p-a-lg">
        <h1 className="m-b-lg">
          {l.translate('Our Support team may help you overcome the difficulties.')}
        </h1>
        <div className="d-flex align-center panel bg-default p-a-md">
          <img
            src={SupportImg}
            className="m-r-xl d-none md-d-block"
            style={{ width: 160, height: 160 }}
          />
          <div>
            <h3>{l.translate('Get help from our Support team')}</h3>
            <p className="m-b-md">
              {l.translate(
                'Please contact our Support team by clicking below if you experience any issues that prevent you from using Manychat at its fullest — your request will be reviewed as soon as possible.',
              )}
            </p>
            <div className="d-flex align-center">
              <LinkBtn
                target="_blank"
                onClick={handleClickSupport}
                href="https://manychat.com/support/features/other/issue/other_other/skipredirect/?chrsk=true"
                size="small"
                variant="primary"
              >
                {l.translate('Reach out to support')}
              </LinkBtn>
            </div>
          </div>
        </div>
        <p className="text-secondary m-b-lg">
          {l.translate(
            'Also we have Manychat Community where you can get help and ask anything you’re worried about',
          )}
        </p>
        <a
          onClick={handleClickCommunity}
          className="text-primary"
          href="https://community.manychat.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          {l.translate('Check out Manychat Community')}
        </a>
      </div>
    </>
  )
}

export default BadExpirence
